<script setup>
import KdContainer from "./kdContainer.vue";

</script>

<template>
  <kd-container>
    <el-form label-width="180px" :model="form" :rules="rules" ref="formRef">
      <div v-for="(sItem, index) in form.suggestionItems" :key="index">
        <div class="suggestionTitle">
          <div>{{ sItem.staffName }}</div>
        </div>
        <div>
          <div v-if="taskDefKey == 'Activity_150gfp6'">
            <el-form-item
              label="是否存在包装问题"
              :prop="`suggestionItems.${index}.hasReasonAnalystMaterial`"
              :rules="rules.hasReasonAnalystMaterial"
            >
              <el-radio-group v-model="sItem.hasReasonAnalystMaterial">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item
              label="是否存在质量问题"
              :prop="`suggestionItems.${index}.hasReasonAnalystMaterial`"
              :rules="rules.hasReasonAnalystMaterial"
            >
              <el-radio-group v-model="sItem.hasReasonAnalystMaterial">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <el-form-item
            label="根因分析"
            :prop="`suggestionItems.${index}.reasonAnalyst`"
            :rules="rules.reasonAnalyst"
          >
            <el-input
              :disabled="true"
              v-model="sItem.reasonAnalyst"
              placeholder="请输入根因分析"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.file"
            ></file-upload-list>
          </el-form-item>
        </div>
      </div>
      <el-divider v-if="showCompletionProcess"></el-divider>
      <el-form-item
        v-if="showCompletionProcess"
        label="是否申请结束流程"
        prop="requestCompletionProcess"
      >
        <el-radio-group
          :disabled="disableForm"
          v-model="form.requestCompletionProcess"
        >
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
          >通过</el-button
        >
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick"
          >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog
        width="600px !important"
        title="审核驳回"
        :visible.sync="dialogVisible"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="rejectFormRef"
          label-width="140px"
        >
          <div
            class="rejectUnitInfo"
            v-for="(item, index) in form.rejectItems"
            :key="index"
          >
            <div class="delButton">
              <el-button
                v-if="index !== 0"
                type="text"
                icon="el-icon-delete"
                @click="delRejectUser(index)"
                >删除</el-button
              >
            </div>
            <el-form-item
              label="驳回责任单位人员"
              :prop="`rejectItems.${index}.userId`"
              :rules="rules.userId"
            >
              <el-select
                filterable
                clearable
                v-model="item.userId"
                placeholder="请选择驳回责任单位人员"
              >
                <el-option
                  v-for="item in userOptions.filter(
                    (optionItem) =>
                      !form.rejectItems.some(
                        (rejectItem) => rejectItem.userId === optionItem.userId
                      ) || optionItem.userId === item.userId
                  )"
                  :key="item.userId"
                  :label="item.staffName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="驳回原因"
              :prop="`rejectItems.${index}.rejectReason`"
              :rules="rules.rejectReason"
            >
              <el-input
                v-model="item.rejectReason"
                type="textarea"
                placeholder="请输入驳回原因"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            v-if="form.suggestionItems.length > form.rejectItems.length"
          >
            <el-button icon="el-icon-plus" type="text" @click="addRejectUser()"
              >新增责任单位人员</el-button
            >
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()"
              >提交</el-button
            >
            <el-button plain @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>
<script>
import { baseURL } from "../../util/url";
import { getAccountUnitUserList } from "../../api/api";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

export default {
  name: "kdQeReasonAnalystAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId: String,
    questionId: String,
    taskDefKey: String,
    suggestionItems: {
      type: Array,
      default: () => [],
    },
    disableForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      userOptions: [],
      assignUser: "",
      dialogVisible: false,
      auditPassDialogVisible: false,
      form: {
        requestCompletionProcess: 0,
        suggestionItems: [],
        rejectItems: [],
        rejectReason: "",
        auditText: "",
      },
      rules: {
        hasReasonAnalystMaterial: [
          {
            required: true,
            message: "是否存在质量问题不能为空",
            trigger: ["blur", "change"],
          },
        ],
        reasonAnalyst: [
          {
            required: true,
            message: "根因分析不能为空",
            trigger: ["blur", "change"],
          },
        ],
        requestCompletionProcess: [
          {
            required: true,
            message: "是否申请结束流程不能为空",
            trigger: ["blur", "change"],
          },
        ],
        userId: [
          {
            required: true,
            message: "驳回责任单位人员不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  computed: {
    showCompletionProcess() {
      return !this.form.suggestionItems.some(
        (item) => item.hasReasonAnalystMaterial == 1
      );
    },
  },
  methods: {
    auditPassBtClick() {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        reasonAnalystDatas: this.form.suggestionItems,
        variables: {
          approval: true,
          qualityEnd: this.form.requestCompletionProcess === 1,
        },
      };
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.form.rejectItems = [
        {
          userId: "",
          rejectReason: "",
        },
      ];
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      });
    },
    addRejectUser() {
      if (this.form.rejectItems.length > this.form.suggestionItems.length) {
        this.$DonMessage.warning("添加驳回数量超过上限！");
        return;
      }
      this.form.rejectItems.push({
        userId: "",
        rejectReason: "",
      });
    },
    delRejectUser(index) {
      this.form.rejectItems.splice(index, 1);
    },
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }

        if (
          this.form.rejectItems.some(
            (item) => item.userId === "" || item.rejectReason === ""
          )
        ) {
          this.$DonMessage.warning("请完善驳回信息！");
          return;
        }
        if (
          new Set(this.form.rejectItems.map((item) => item.userId)).size !==
          this.form.rejectItems.length
        ) {
          this.$DonMessage.warning("请勿重复选择用户！");
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
          rejectItems: this.form.rejectItems,
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.dialogVisible = false;
            this.backRouterPath();
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    addWeightUser() {
      this.form.suggestionItems.push({
        assignUser: "",
        handSuggestion: "",
        file: [],
      });
    },
  },
  mounted() {
    this.form.suggestionItems = this.suggestionItems;
    if (this.form.suggestionItems) {
      this.form.suggestionItems.forEach((item) => {
        item.hasReasonAnalystMaterial = 1;
      });
    }
    this.userOptions = this.suggestionItems;
  },
};
</script>
